export type FitMeasurement = {
  valueRightEdges: number[];
  availableWidth: number;
  isOverflowing: boolean;
};

export const countFittingValues = ({
  valueRightEdges,
  availableWidth,
  isOverflowing,
}: FitMeasurement): number => {
  if (!isOverflowing) return valueRightEdges.length;
  const fitting = valueRightEdges.filter((rightEdge) => rightEdge <= availableWidth).length;
  return Math.max(1, fitting);
};
